import type { ReactNode } from "react";
import DateRangeFilter from "src/components/DateRangeFilter";

type DateRange = [Date | null, Date | null];

type DatePresetRange = {
  label: string;
  value: number;
};

type HistoryPageControlsProps = {
  title: string;
  action?: ReactNode;
  dateRange: DateRange;
  disabled?: boolean;
  datePresetRanges?: DatePresetRange[];
  onDateRangeChange: (dateRange: DateRange) => void;
};

const HistoryPageControls = (props: HistoryPageControlsProps) => {
  const { title, action, dateRange, disabled, datePresetRanges, onDateRangeChange } = props;

  return (
    <div className="history-page-controls">
      <div className="history-page-controls__title-row">
        <h1>{title}</h1>
        {action && <div className="history-page-controls__action">{action}</div>}
      </div>
      <div className="history-page-controls__date-filter">
        <DateRangeFilter //
          datePresetRanges={datePresetRanges}
          disabled={disabled}
          dateRange={dateRange}
          onDateRangeChange={onDateRangeChange}
        />
      </div>
    </div>
  );
};

export default HistoryPageControls;
